import * as actionTypes from '../actionTypes/dittoShare';

export function loadDittoShare(dittoId, formData) {
  return { type: actionTypes.DITTO_SHARE_DATA_LOAD, dittoId, formData };
}

export function setDittoShareFromStorage(fileLocation) {
  return { type: actionTypes.SET_DITTO_SHARE_FROM_STORAGE, fileLocation };
}
